import { useState, useEffect } from "react";
import { Card, Form, Input, Button, Row, Col, Typography, message } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { encryptData, decryptData } from '../middleware/encryption';
import './Signup.css';
import "antd/dist/reset.css";
import logo from '../assets/lead-finder-white.jpg';

export default function ResetPassword() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { email } = useParams();
  const [decodedEmail, setDecodedEmail] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (email) {
      setDecodedEmail(atob(email));
    }
  }, [email]);

  
  const handleSubmit = (values) => {
    if (values.newPassword !== values.confirmPassword) {
      message.error("Passwords do not match");
      return;
    }

    setLoading(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      email: decodedEmail,
      otp: values.otp,
      newPassword: values.newPassword
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow"
    };

    fetch("https://api.app.exellius.com/api/auth/reset-password", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);
        if (result.data) {
          const decryptedResponse = decryptData(result.data);
          console.log(decryptedResponse);
          message.success(decryptedResponse.message || "Password reset successful");
         navigate('/login');
        } else {
          message.error(result.message || "Password reset failed");
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error(error);
       
      });
  };

  return (
    <Row className="signup-container">
      {/* Left Side - Form */}
      <Col xs={24} md={12} className="signup-form-container">
        <Card className="signup-card">
          <div className="signup-logo">
            <img src={logo} alt="Logo" style={{height:"50px",width:"auto"}} />
          </div>
          <Typography.Title level={2} className="signup-title" style={{color:"black",fontWeight:800}}>Reset Password</Typography.Title>
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <Form.Item name="otp" label="OTP" rules={[{ required: true, message: "Please enter the OTP" }]}> 
              <Input size="large" placeholder="Enter OTP" />
            </Form.Item>
            <Form.Item name="newPassword" label="New Password" rules={[{ required: true, message: "Please enter your new password" }]}> 
              <Input.Password size="large" placeholder="Enter new password" />
            </Form.Item>
            <Form.Item name="confirmPassword" label="Confirm Password" dependencies={["newPassword"]} rules={[{ required: true, message: "Please confirm your new password" }, ({ getFieldValue }) => ({ validator(_, value) { return !value || getFieldValue("newPassword") === value ? Promise.resolve() : Promise.reject(new Error("Passwords do not match")); } })]}> 
              <Input.Password size="large" placeholder="Confirm new password" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" size="large" className="signup-button" block loading={loading}>Submit</Button>
            </Form.Item>
            <Form.Item>
              <Button type="default" size="large" className="signup-button" block onClick={() => navigate('/login')}>Back to Login</Button>
            </Form.Item>
          </Form>
        </Card>
      </Col>

      {/* Right Side - Image */}
      <Col xs={0} md={12} className="signup-image-container">
        <div>
          <img src="https://app.success.ai/static/media/section1-3.39df0c32ebe092599f26.png" alt="Right Side" className="signup-image" />
          <div className="signup-text-container">
            <Typography.Title level={3} className="signup-text-title">Easily find great leads with our strong database</Typography.Title>
            <Typography.Text className="signup-text">Quickly find valuable leads with our rich database, making your search easier and boosting your growth.</Typography.Text>
          </div>
        </div>
      </Col>
    </Row>
  );
}
